module.exports = __webpack_public_path__ + "img/eye_muscles_gray.9fcc69af.png";